module.exports = __webpack_public_path__ + "static/media/check-circle.54ffa78d.svg";